export default __webpack_public_path__ + "static/media/orders.af00b418.png";